import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const FavouriteBrandsPage = lazy(
  () =>
    import('./FavouriteBrandsPage.eager').then(mod => ({
      default: mod.FavouriteBrandsPage,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
    isSsrAndNeedsHydration: true,
  },
);
